import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getEmpleos, fileUrl } from "@/lib/api";
import { Briefcase, MapPin, Building2, ExternalLink, Mail } from "lucide-react";

export default function PortalEmpleo() {
  const { data: ofertas = [], isLoading } = useQuery({ queryKey: ["empleos"], queryFn: getEmpleos });

  return (
    <div data-testid="portal-empleo">
      <div className="main-head">
        <div>
          <h1>Portal de empleo <span className="gold-it">y proyectos</span></h1>
          <p className="sub">Ofertas de empleo y proyectos reales de IA. Aplica, colabora y factura con clientes de la comunidad.</p>
        </div>
      </div>

      {isLoading ? (
        <p style={{ color: "var(--muted)" }}>Cargando ofertas…</p>
      ) : ofertas.length === 0 ? (
        <p style={{ color: "var(--muted)" }} data-testid="empleo-vacio">Todavía no hay ofertas publicadas. Vuelve pronto: subimos nuevas oportunidades cada semana.</p>
      ) : (
        <div className="empleo-grid" data-testid="empleo-grid">
          {ofertas.map((o) => (
            <div className="empleo-card" key={o.id} data-testid={`empleo-${o.id}`}>
              {o.imagen && <img src={fileUrl(o.imagen)} alt="" className="empleo-img" data-testid={`empleo-img-${o.id}`} />}
              <span className={`empleo-tag ${o.tipo === "proyecto" ? "proyecto" : ""}`}>
                <Briefcase size={12} /> {o.tipo === "proyecto" ? "Proyecto" : "Empleo"}
              </span>
              <h3>{o.titulo}</h3>
              <div className="empleo-meta">
                {o.empresa && <span><Building2 size={13} /> {o.empresa}</span>}
                {o.ubicacion && <span><MapPin size={13} /> {o.ubicacion}</span>}
              </div>
              {o.descripcion && <p className="empleo-desc">{o.descripcion}</p>}
              <div className="empleo-actions">
                {o.enlace && (
                  <a className="btn btn-gold btn-sm" href={o.enlace} target="_blank" rel="noopener noreferrer" data-testid={`empleo-aplicar-${o.id}`}>
                    Aplicar <ExternalLink size={14} />
                  </a>
                )}
                {o.contacto && (
                  <a className="abtn" href={o.contacto.includes("@") ? `mailto:${o.contacto}` : o.contacto}
                    target="_blank" rel="noopener noreferrer" style={{ display: "inline-flex", gap: 6, alignItems: "center" }}>
                    <Mail size={13} /> Contacto
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
